module.exports = __webpack_public_path__ + "img/envelope.0b78cbf7.svg";